import { QueryResult } from 'react-query';
// eslint-disable-next-line
import React from 'react';
import Select from 'components/forms/Select';
import { TextFieldProps } from 'formik-material-ui';
import dictionary from 'utils/dictionary';

type Props = {
  asyncState: QueryResult<any, any>;
} & TextFieldProps;

const SelectDocument: React.FC<Props> = ({ asyncState, ...restProps }) => {
  const { data, error, isLoading } = asyncState;
  return (
    <Select
      SelectProps={{
        SelectDisplayProps: {
          'data-testid': restProps.id,
        } as any,
      }}
      label={dictionary.searchDocument_label_docType}
      bindLabel="id"
      bindValue="id"
      items={data}
      isLoading={isLoading}
      error={error}
      // onRefresh={refetch}
      {...restProps}
    />
  );
};

export default SelectDocument;
